import { render, staticRenderFns } from "./BindsPasswordOnIcon.vue?vue&type=template&id=30bc9fb4&"
import script from "./BindsPasswordOnIcon.vue?vue&type=script&lang=js&"
export * from "./BindsPasswordOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports